import React, { useState } from 'react';
import { MailCheck, LogOut } from 'lucide-react';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import { resendVerification } from '../utils/api';

// Rendered in place of the app shell by App.jsx's PrivateRoute whenever a
// logged-in user hasn't confirmed their email yet — every other API call
// they could make is already blocked server-side, so this is the only
// screen there's anything useful to do.
export default function VerifyEmailPending() {
  const { user, logout } = useAuth();
  const [sending, setSending] = useState(false);

  const handleResend = async () => {
    setSending(true);
    try {
      await resendVerification();
      toast.success('Verification email sent — check your inbox.');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to resend email');
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 50%, #0F172A 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 440, background: '#fff', borderRadius: 16, padding: '36px', boxShadow: '0 25px 50px rgba(0,0,0,.4)', textAlign: 'center' }}>
        <div style={{ width: 56, height: 56, background: 'var(--bg3)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
          <MailCheck size={26} color="var(--primary)" />
        </div>
        <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Verify your email</h2>
        <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 20 }}>
          We sent a confirmation link to <strong>{user?.email}</strong>. Click it to activate your account.
        </p>
        <button className="btn btn-primary btn-lg" onClick={handleResend} disabled={sending} style={{ width: '100%', justifyContent: 'center', marginBottom: 10 }}>
          {sending ? 'Sending...' : 'Resend verification email'}
        </button>
        <button className="btn btn-secondary" onClick={logout} style={{ width: '100%', justifyContent: 'center', display: 'flex', alignItems: 'center', gap: 6 }}>
          <LogOut size={14} /> Sign out
        </button>
      </div>
    </div>
  );
}
